/*
 * ttg-geschenkbeutel.js — Personalisierter Geschenkbeutel als Zusatz-Karte (Phase 1, 21.10.2026)
 * ---------------------------------------------------------------------------
 * Briefing geschenkbeutel-2026-10-21-briefing-phase1-komplett.md (B2). Nur auf den
 * zwei Pfotenabdruck-Sets (Template-Suffix pfotenabdruck-set). Eigenständig: die
 * Konfigurator-Engine (ttg-engine.js) und die Mini-Vorschau werden nicht benutzt.
 *
 * Ablauf:
 *   - Schalter „Als Geschenk verpacken?“ steht auf Nein. Bei Ja klappt die Karte auf:
 *     Beutelfarbe → Motiv (3 × 2) → Druckfarbe → Wunschtext → Live-Vorschau.
 *   - Kaufknopf: Ist der Schalter an, fängt diese Datei das Absenden des Produkt-
 *     formulars ab (capture, vor product-form.js) und legt Set + Beutel + ggf.
 *     Farb-Aufpreis in EINEM /cart/add.js-Aufruf in den Warenkorb.
 *     Verknüpfung wie in ttg-cart-reconciler.js / cart-products.liquid:
 *     gemeinsames _ttg_group je Hinzufügen, Beutel und Aufpreis mit _ttg_role
 *     'surcharge' → Menge folgt dem Set, ohne Set räumt der Reconciler sie ab.
 *   - Express-Checkout: Solange der Schalter an ist, blendet die Body-Klasse
 *     ttg-gb-an die dynamischen Checkout-Knöpfe aus (CSS). Sonst kauft der
 *     Kunde das Set ohne Beutel.
 * Fehlt die Config oder der Beutel (Produkt noch nicht angelegt), rendert die
 * Karte nichts und das Formular bleibt unberührt.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';
  if (customElements.get('ttg-geschenkbeutel')) return;

  // label = Anzeige in Karte und Warenkorb, speicher = Bestellangabe „Druckfarbe“ in der Form des Geschenksets
  // (geschenkset-ostern: „Weiss“), damit die Produktion beide gleich liest (Jens 21.10.2026, Punkt 10).
  var DRUCKFARBEN = [
    { value: 'weiss', label: 'Weiß', speicher: 'Weiss', hex: '#ffffff' },
    { value: 'schwarz', label: 'Schwarz', speicher: 'Schwarz', hex: '#000000' },
    { value: 'gold', label: 'Gold', speicher: 'Gold', hex: '#c7a63f', aufpreis: true },
    { value: 'silber', label: 'Silber', speicher: 'Silber', hex: '#969696', aufpreis: true },
  ];
  // Beutelfarbe: Varianten heißen „Bordeaux“, das Geschenkset speichert „bordeaux“ → Bestellangabe in Geschenkset-Form
  var BEUTEL_SPEICHER = { 'Bordeaux': 'bordeaux' };
  // Beutelfarbe → Farbfeld (nur Anzeige) und gesperrte, gleichfarbige Druckfarbe
  var BEUTEL_HEX = { 'Schwarz': '#1d1d1f', 'Weiß': '#f3f2ee', 'Rot': '#c41e2c', 'Bordeaux': '#6b1622', 'Grün': '#2e8b3a' };
  var GLEICHFARBIG = { 'Weiß': 'weiss', 'Schwarz': 'schwarz' };
  // Druckfläche je Beutelfoto (Anteile x0, y0, x1, y1 am Bild). Gemessen 21.10.2026 an den Variantenbildern
  // Baumwolle-*.jpg von geschenk-set-ostern (Beutelkörper per Freistellung, Fläche 20–80 % Breite, 36–92 % Höhe).
  // Die Fotos sind unterschiedlich gerahmt, deshalb je Farbe ein eigener Wert.
  var DRUCKFLAECHEN = {
    'Grün': [0.3242, 0.3886, 0.6578, 0.7941], 'Rot': [0.3298, 0.374, 0.6682, 0.7879],
    'Schwarz': [0.3204, 0.374, 0.6786, 0.7879], 'Weiß': [0.3128, 0.3906, 0.6422, 0.7882],
    'Bordeaux': [0.3514, 0.389, 0.6616, 0.7889],
  };
  var ERLAUBTE_EMOJI = ['❤', '🐾'];
  var MAX_ZEILEN = 2, MAX_ZEICHEN = 20;

  function vorwahlDruck(farbe) { return farbe === 'Weiß' ? 'schwarz' : 'weiss'; }
  function euro(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function el(tag, attrs, kinder) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (attrs[k] !== false && attrs[k] != null) n.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (kinder || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }

  /** Emoji-Regel: nur Herz und Pfote. ♥ / ❤️ werden zu ❤ vereinheitlicht, alles andere fällt weg. */
  function textBereinigen(roh) {
    var t = String(roh || '').replace(/\r/g, '').replace(/♥|❤️/g, '❤').replace(/️/g, '');
    var entfernt = false;
    t = t.replace(/\p{Extended_Pictographic}/gu, function (z) {
      if (ERLAUBTE_EMOJI.indexOf(z) >= 0) return z;
      entfernt = true; return '';
    });
    var zeilen = t.split('\n').slice(0, MAX_ZEILEN).map(function (z) { return Array.from(z).slice(0, MAX_ZEICHEN).join(''); });
    return { text: zeilen.join('\n'), entfernt: entfernt };
  }

  class TTGGeschenkbeutel extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      var roh = this.querySelector('script[data-ttg-gb-config]');
      try { this.cfg = JSON.parse(roh ? roh.textContent : 'null'); } catch (e) { this.cfg = null; }
      if (!this.cfg || !this.cfg.beutel || !this.cfg.beutel.length || !this.cfg.motive || !this.cfg.motive.length) {
        console.warn('[ttg-geschenkbeutel] Config unvollständig – Karte bleibt aus.');
        return;
      }
      this._init = true;
      var start = this.cfg.beutel.find(function (b) { return b.farbe === 'Rot'; }) || this.cfg.beutel[0];
      this.state = { an: false, farbe: start.farbe, motiv: this.cfg.motive[0].handle, druck: vorwahlDruck(start.farbe), text: '' };
      this._bilder = {};
      this._bauen();
      this._formularVerbinden();
      this._aktualisieren();
    }

    disconnectedCallback() {
      document.body.classList.remove('ttg-gb-an');
      if (this._submit) window.removeEventListener('submit', this._submit, true);
    }

    // ---------- Aufbau ----------
    _bauen() {
      var self = this, c = this.cfg, ui = this.querySelector('[data-ttg-gb-ui]');
      this.ui = ui; ui.textContent = '';

      // Kopfzeile mit Schalter
      this.kopfBild = el('img', { class: 'ttg-gb__kopfbild', alt: '', width: '48', height: '48', loading: 'lazy' });
      this.schalter = el('button', { type: 'button', class: 'ttg-gb__schalter', role: 'switch', 'aria-checked': 'false', 'aria-controls': 'ttg-gb-karte' }, [
        el('span', { class: 'ttg-gb__schalter-knopf', 'aria-hidden': 'true' }),
      ]);
      this.schalter.setAttribute('aria-label', 'Als Geschenk verpacken');
      var kopf = el('div', { class: 'ttg-gb__kopf' }, [
        this.kopfBild,
        el('div', { class: 'ttg-gb__kopftext' }, [
          el('span', { class: 'ttg-gb__frage', text: 'Als Geschenk verpacken?' }),
          el('span', { class: 'ttg-gb__unterzeile', text: 'Personalisierter Geschenkbeutel · +' + euro(c.beutel_preis_cents) }),
        ]),
        this.schalter,
      ]);
      kopf.addEventListener('click', function (e) { if (e.target.closest('.ttg-gb__schalter') || e.target.closest('.ttg-gb__kopftext') || e.target === self.kopfBild) self._schalten(); });

      // Karte
      this.karte = el('div', { class: 'ttg-gb__karte', id: 'ttg-gb-karte', hidden: true });

      // 1 Beutelfarbe
      this.farbReihe = el('div', { class: 'ttg-gb__farben', role: 'radiogroup', 'aria-label': 'Beutelfarbe' });
      c.beutel.forEach(function (b) {
        var knopf = el('button', { type: 'button', class: 'ttg-gb__farbe', role: 'radio', 'data-farbe': b.farbe, title: b.farbe, 'aria-label': b.farbe },
          [el('span', { class: 'ttg-gb__farbe-punkt', style: 'background:' + (BEUTEL_HEX[b.farbe] || '#ccc') })]);
        knopf.addEventListener('click', function () { self._farbeWaehlen(b.farbe); });
        self.farbReihe.appendChild(knopf);
      });
      this.farbName = el('span', { class: 'ttg-gb__wert' });

      // 2 Motiv 3 × 2
      this.motivRaster = el('div', { class: 'ttg-gb__motive', role: 'radiogroup', 'aria-label': 'Motiv' });
      c.motive.forEach(function (m) {
        var knopf = el('button', { type: 'button', class: 'ttg-gb__motiv', role: 'radio', 'data-motiv': m.handle, 'aria-label': m.label },
          [el('img', { src: m.bild, alt: '', loading: 'lazy' }), el('span', { class: 'ttg-gb__motiv-name', text: m.label })]);
        knopf.addEventListener('click', function () { self.state.motiv = m.handle; self._aktualisieren(); });
        self.motivRaster.appendChild(knopf);
      });

      // 3 Druckfarbe
      this.druckReihe = el('div', { class: 'ttg-gb__druckfarben', role: 'radiogroup', 'aria-label': 'Druckfarbe' });
      DRUCKFARBEN.forEach(function (d) {
        var preis = (d.aufpreis && c.aufpreis && c.aufpreis.aktiv) ? el('span', { class: 'ttg-gb__aufpreis', text: c.aufpreis.label }) : null;
        var knopf = el('button', { type: 'button', class: 'ttg-gb__druck', role: 'radio', 'data-druck': d.value, 'aria-label': d.label + (preis ? ', ' + c.aufpreis.label : '') }, [
          el('span', { class: 'ttg-gb__druck-punkt', style: 'background:' + d.hex }),
          el('span', { class: 'ttg-gb__druck-name', text: d.label }),
          preis,
        ]);
        knopf.addEventListener('click', function () {
          if (knopf.getAttribute('aria-disabled') === 'true') return;
          self.state.druck = d.value; self._aktualisieren();
        });
        self.druckReihe.appendChild(knopf);
      });
      this.druckHinweis = el('p', { class: 'ttg-gb__hinweis', hidden: true });

      // 4 Wunschtext
      this.textFeld = el('textarea', { class: 'ttg-gb__text', rows: '2', placeholder: 'z. B. Für Bello', 'aria-label': 'Wunschtext, freiwillig, 2 Zeilen mit je 20 Zeichen' });
      this.textHinweis = el('p', { class: 'ttg-gb__hinweis', hidden: true });
      this.textFeld.addEventListener('input', function () {
        var r = textBereinigen(self.textFeld.value);
        if (r.text !== self.textFeld.value) {
          var pos = self.textFeld.selectionStart; self.textFeld.value = r.text;
          try { self.textFeld.setSelectionRange(Math.min(pos, r.text.length), Math.min(pos, r.text.length)); } catch (e) { /* egal */ }
        }
        self.textHinweis.hidden = !r.entfernt;
        self.textHinweis.textContent = r.entfernt ? 'Gedruckt werden nur ❤ und 🐾 – andere Emojis haben wir entfernt.' : '';
        self.state.text = r.text; self._vorschau(); self._preis();
      });

      // 5 Vorschau
      this.leinwand = el('canvas', { class: 'ttg-gb__vorschau', width: '600', height: '600', role: 'img', 'aria-label': 'Vorschau deines Geschenkbeutels' });

      this.fehler = el('p', { class: 'ttg-gb__fehler', role: 'alert', hidden: true });

      function gruppe(titel, wert, inhalt) {
        return el('div', { class: 'ttg-gb__gruppe' }, [el('p', { class: 'ttg-gb__titel' }, [el('span', { text: titel }), wert]), inhalt]);
      }
      [
        gruppe('Beutelfarbe', this.farbName, this.farbReihe),
        gruppe('Motiv', null, this.motivRaster),
        gruppe('Druckfarbe', null, el('div', {}, [this.druckReihe, this.druckHinweis])),
        gruppe('Wunschtext (freiwillig)', null, el('div', {}, [this.textFeld, el('p', { class: 'ttg-gb__klein', text: '2 Zeilen mit je 20 Zeichen, Schrift Handschrift. ❤ und 🐾 drucken wir mit.' }), this.textHinweis])),
        gruppe('So sieht dein Beutel aus', null, this.leinwand),
        this.fehler,
      ].forEach(function (n) { self.karte.appendChild(n); });

      ui.appendChild(el('div', { class: 'ttg-gb__rahmen' }, [kopf, this.karte]));
      this._schriftLaden();
    }

    _schriftLaden() {
      var self = this;
      if (!this.cfg.schrift_url || !window.FontFace) return;
      var f = new FontFace('TTG Handschrift GB', 'url(' + this.cfg.schrift_url + ')');
      f.load().then(function (ff) { document.fonts.add(ff); self._schriftDa = true; self._vorschau(); }).catch(function () { /* Vorschau nimmt Ersatzschrift */ });
    }

    // ---------- Zustand ----------
    _schalten() {
      this.state.an = !this.state.an;   // Auswahl bleibt beim Aus- und Einschalten erhalten
      this._aktualisieren();
      if (this.state.an) this._vorschau();
    }

    _farbeWaehlen(farbe) {
      this.state.farbe = farbe;
      // Gleichfarbig gesperrt → Sprung auf die Vorwahl der neuen Beutelfarbe
      if (GLEICHFARBIG[farbe] === this.state.druck) this.state.druck = vorwahlDruck(farbe);
      this._aktualisieren();
    }

    _beutel() { var f = this.state.farbe; return this.cfg.beutel.find(function (b) { return b.farbe === f; }); }
    _motiv() { var h = this.state.motiv; return this.cfg.motive.find(function (m) { return m.handle === h; }); }
    _druck() { var v = this.state.druck; return DRUCKFARBEN.find(function (d) { return d.value === v; }); }
    _mitAufpreis() { return !!(this._druck().aufpreis && this.cfg.aufpreis && this.cfg.aufpreis.aktiv && this.cfg.aufpreis.variante); }

    _aktualisieren() {
      var s = this.state, self = this;
      this.schalter.setAttribute('aria-checked', String(s.an));
      this.karte.hidden = !s.an;
      this.classList.toggle('ttg-gb--an', s.an);
      document.body.classList.toggle('ttg-gb-an', s.an);
      var b = this._beutel();
      this.kopfBild.src = b.bild_klein || b.bild;
      this.farbName.textContent = s.farbe;
      this.farbReihe.querySelectorAll('[data-farbe]').forEach(function (n) { n.setAttribute('aria-checked', String(n.dataset.farbe === s.farbe)); });
      this.motivRaster.querySelectorAll('[data-motiv]').forEach(function (n) { n.setAttribute('aria-checked', String(n.dataset.motiv === s.motiv)); });
      var gesperrt = GLEICHFARBIG[s.farbe];
      this.druckReihe.querySelectorAll('[data-druck]').forEach(function (n) {
        var aus = n.dataset.druck === gesperrt;
        n.setAttribute('aria-disabled', String(aus));
        n.title = aus ? 'Auf dem ' + s.farbe.toLowerCase().replace('weiß', 'weißen').replace('schwarz', 'schwarzen') + ' Beutel nicht sichtbar' : '';
        n.setAttribute('aria-checked', String(n.dataset.druck === s.druck));
      });
      this.druckHinweis.hidden = !gesperrt;
      this.druckHinweis.textContent = gesperrt ? 'Auf dem ' + (s.farbe === 'Weiß' ? 'weißen' : 'schwarzen') + ' Beutel wäre ' + (gesperrt === 'weiss' ? 'Weiß' : 'Schwarz') + ' nicht zu sehen.' : '';
      this._preis();
      if (s.an) this._vorschau();
    }

    // ---------- Preis im Kaufknopf ----------
    _formular() {
      var sektion = this.closest('.shopify-section') || document;
      return sektion.querySelector('product-form-component form[data-type="add-to-cart-form"]') || document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    }
    _menge() { var f = this._formular(); var q = f && f.querySelector('input[name="quantity"]'); return Math.max(1, parseInt(q && q.value, 10) || 1); }
    _summeCents() {
      var proStueck = this.cfg.set_preis_cents + (this.state.an ? this.cfg.beutel_preis_cents + (this._mitAufpreis() ? this.cfg.aufpreis.cents : 0) : 0);
      return proStueck * this._menge();
    }
    _preis() {
      var f = this._formular(); if (!f) return;
      var knoepfe = [];
      var id = f.getAttribute('id');
      document.querySelectorAll('button[type="submit"][form="' + id + '"], #' + CSS.escape(id) + ' button[type="submit"]').forEach(function (k) { knoepfe.push(k); });
      var self = this;
      knoepfe.forEach(function (k) {
        var ziel = k.querySelector('.add-to-cart-text__content span span') || k.querySelector('.add-to-cart-text__content');
        if (!ziel) return;
        if (ziel.dataset.ttgGbOriginal == null) ziel.dataset.ttgGbOriginal = ziel.textContent.trim();
        ziel.textContent = self.state.an ? ziel.dataset.ttgGbOriginal + ' · ' + euro(self._summeCents()) : ziel.dataset.ttgGbOriginal;
      });
    }

    // ---------- Vorschau ----------
    _bild(url) {
      if (!url) return Promise.resolve(null);
      if (!this._bilder[url]) {
        this._bilder[url] = new Promise(function (ok) {
          var i = new Image(); i.crossOrigin = 'anonymous';
          i.onload = function () { ok(i); }; i.onerror = function () { ok(null); }; i.src = url;
        });
      }
      return this._bilder[url];
    }

    _vorschau() {
      var self = this, b = this._beutel(), m = this._motiv(), d = this._druck(), nr = (this._vNr = (this._vNr || 0) + 1);
      Promise.all([this._bild(b.bild), this._bild(m.bild)]).then(function (r) {
        if (nr !== self._vNr) return;
        var cv = self.leinwand, ctx = cv.getContext('2d'), W = cv.width, H = cv.height;
        ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, H);
        if (r[0]) ctx.drawImage(r[0], 0, 0, W, H);
        var fl = DRUCKFLAECHEN[b.farbe] || [0.33, 0.38, 0.67, 0.79];
        var x0 = fl[0] * W, y0 = fl[1] * H, fw = (fl[2] - fl[0]) * W, fh = (fl[3] - fl[1]) * H;
        var zeilen = self.state.text ? self.state.text.split('\n').filter(function (z) { return z.trim(); }) : [];
        var textH = zeilen.length ? fh * (zeilen.length === 1 ? 0.2 : 0.34) : 0;
        var motivMax = Math.min(fw, fh - textH - (zeilen.length ? fh * 0.04 : 0));
        if (r[1]) {
          // Motiv in Druckfarbe einfärben (source-in auf eigener Ebene)
          var tmp = document.createElement('canvas'); tmp.width = tmp.height = Math.round(motivMax);
          var t = tmp.getContext('2d'); t.drawImage(r[1], 0, 0, tmp.width, tmp.height);
          t.globalCompositeOperation = 'source-in'; t.fillStyle = d.hex; t.fillRect(0, 0, tmp.width, tmp.height);
          ctx.drawImage(tmp, x0 + (fw - motivMax) / 2, y0, motivMax, motivMax);
        }
        if (zeilen.length) {
          var zeileH = textH / zeilen.length, groesse = zeileH * 0.82;
          var font = (self._schriftDa ? '"TTG Handschrift GB"' : '"Comic Sans MS", cursive');
          ctx.fillStyle = d.hex; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          zeilen.forEach(function (z, i) {
            var g = groesse; ctx.font = g + 'px ' + font;
            while (ctx.measureText(z).width > fw && g > 8) { g -= 1; ctx.font = g + 'px ' + font; }
            ctx.fillText(z, x0 + fw / 2, y0 + fh - textH + zeileH * (i + 0.5));
          });
        }
      });
    }

    // ---------- Warenkorb ----------
    _formularVerbinden() {
      var self = this;
      this._submit = function (e) {
        var f = self._formular();
        if (!self.state.an || !f || e.target !== f) return;
        e.preventDefault(); e.stopImmediatePropagation();
        self._hinzufuegen(f);
      };
      // window + capture: läuft VOR dem Theme. component.js hängt seine on:submit-Delegation mit capture an document
      // und wird beim Modul-Laden registriert, also vor diesem Skript — ein document-Listener käme zu spät und das
      // Theme legte das Set zusätzlich allein (ohne _ttg_group) in den Warenkorb (Dev-Theme-Test 21.10.2026).
      window.addEventListener('submit', this._submit, true);
      var f = this._formular();
      if (f) f.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') self._preis(); });
      document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') self._preis(); });
    }

    _positionen(form) {
      var c = this.cfg, s = this.state, b = this._beutel(), m = this._motiv(), d = this._druck(), menge = this._menge();
      var gruppe = 'gb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var setId = Number(new FormData(form).get('id'));
      var wert = [s.farbe, m.label, d.label].concat(s.text ? ['„' + s.text.replace(/\n/g, ' / ') + '“'] : []).join(' · ');
      var beutelProps = {
        'Farbe Geschenkbeutel': BEUTEL_SPEICHER[s.farbe] || s.farbe,
        'Motiv': m.label,
        'Schrift': 'Handschrift',
        'Druckfarbe': d.speicher,
        // Wie die Engine (ttg-engine.js _motiv_*): Metaobjekt-Nummer, MediaImage-Nummer, Dateiname — danach arbeitet die Produktion
        '_motiv_id': String(m.id || m.handle),
        '_motiv_bild': String(m.bild_id || m.bild_gross || m.bild),
        '_motiv_datei': String(m.bild_gross || m.bild).split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, ''),
        '_Druckfarbe Hex': d.hex,
        '_ttg_group': gruppe,
        '_ttg_role': 'surcharge',
        '_ttg_kind': 'beutel',
        '_ttg_value': wert,
        '_ttg_ref': c.set_titel + ' — Geschenkbeutel: ' + wert,
      };
      if (s.text) beutelProps['Wunschtext'] = s.text;
      var items = [
        { id: setId, quantity: menge, properties: { _ttg_group: gruppe } },
        { id: b.id, quantity: menge, properties: beutelProps },
      ];
      if (this._mitAufpreis()) {
        items.push({ id: Number(String(c.aufpreis.variante).match(/(\d+)\s*$/)[1]), quantity: menge, properties: {
          _ttg_group: gruppe, _ttg_role: 'surcharge', _ttg_kind: 'color', _ttg_value: d.label,
          _ttg_ref: c.set_titel + ' — Geschenkbeutel Druckfarbe: ' + d.label,
        } });
      }
      return { items: items, gruppe: gruppe };
    }

    /** Vorschaubild nicht-blockierend nachtragen: Auftrag an ttg-preview-uploader (lädt auf /cart hoch und
     *  trägt die URL als _preview_image an die BEUTEL-Zeile der Gruppe ein, Ziel role surcharge / kind beutel —
     *  Jens 21.10.2026, Punkt 7; die Produktion liest _preview_image wie beim Geschenkset). Die Set-Zeile
     *  bleibt unberührt. Fehlt Uploader oder Bild (z. B. CORS), bleibt es still beim Fallback. */
    _vorschauAuftrag(gruppe) {
      var v = this.cfg.vorschau, up = window.__ttgPreviewUploader;
      if (!v || !v.url || !up || typeof up.stash !== 'function') return;
      try {
        up.stash({ group: gruppe, dataUrl: this.leinwand.toDataURL('image/jpeg', 0.85), url: v.url,
          property: v.property || '_preview_image', maxUploadBytes: v.maxUploadBytes || 512000,
          ziel: { role: 'surcharge', kind: 'beutel' } });
      } catch (e) { console.warn('[ttg-geschenkbeutel] Vorschau-Auftrag übersprungen:', e && e.message); }
    }

    _hinzufuegen(form) {
      var self = this, knopf = form.querySelector('button[type="submit"]');
      this.fehler.hidden = true;
      if (knopf) knopf.setAttribute('aria-busy', 'true');
      var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
      if (!/\.js$/.test(url)) url += '.js';
      var pos = this._positionen(form);
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: pos.items }),
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || ('HTTP ' + r.status)); return j; });
      }).then(function () {
        self._vorschauAuftrag(pos.gruppe);
        window.location.assign((window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart');
      }).catch(function (e) {
        console.error('[ttg-geschenkbeutel] Warenkorb:', e);
        self.fehler.textContent = 'Das hat gerade nicht geklappt: ' + e.message + ' Bitte versuch es noch einmal.';
        self.fehler.hidden = false;
        if (knopf) knopf.removeAttribute('aria-busy');
      });
    }
  }

  customElements.define('ttg-geschenkbeutel', TTGGeschenkbeutel);
})();
